<div class="panel-table table-responsive">
  <header class="panel-table blue">
    <h1 id="descricao-tabela" class="panel-table-title">
      {{ isFabrica ? 'RELATÓRIOS DE PRODUÇÃO' : tituloRelatorio }}
    </h1>
    <span class="panel-table-subtitle"
      >Clique no cabeçalho das tabelas para classificá-las.</span
    >
  </header>

  <div class="panel-table-content table-responsive">
    <div class="menu">
      <nav aria-label="Menu com opções de exportação do relatório">
        <button
          type="button"
          class="btn btn-primary blue mr-10"
          (click)="onClickExportarExcel()"
          *ngIf="!isLojaMatriz || filtros?.relatorio?.idRelatorio === 16"
        >
          Exportar
        </button>

        <button
          type="button"
          class="btn btn-primary blue mr-10"
          (click)="onClickExportarExcelAgrupado()"
          *ngIf="isLojaMatriz && filtros?.relatorio?.idRelatorio !== 16"
        >
          Exportar Agrupado
        </button>

        <button
          type="button"
          class="btn btn-primary blue"
          (click)="onClickExportarExcel()"
          *ngIf="isLojaMatriz && filtros?.relatorio?.idRelatorio !== 16"
        >
          Exportar Detalhado
        </button>

        <button
          *ngIf="clicouDetalhes"
          type="button"
          class="btn btn-primary blue"
          (click)="voltar()"
        >
          Voltar
        </button>
      </nav>

      <div class="header-title" *ngIf="!isLojaMatriz">
        Agente: {{ relatorios[0]?.agente }} -
        {{
          relatorios[0]?.lojista?.nomeFantasia ||
            relatorios[0]?.lojista?.razaoSocial
        }}
        - CNPJ:
        {{ relatorios[0]?.lojista.cnpj | cnpj }}
      </div>

      <div>
        <label class="ajuste-label">Procurar</label>
        <input
          class="input-search"
          type="text"
          name="search"
          placeholder="Digite aqui para pesquisar..."
          [(ngModel)]="filter"
        />
      </div>
    </div>

    <ng-container *ngIf="!isFabrica; else relatorioFabricaTemplate">
      <table
        aria-describedby="descricao-tabela"
        *ngIf="isLojaMatriz"
        class="table"
      >
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" (click)="sort('idLojista')">
              <span
                *ngIf="key === 'idLojista'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Código
            </th>
            <th scope="col" (click)="sort('nomeFantasiaLojista')">
              <span
                *ngIf="key === 'nomeFantasiaLojista'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Loja
            </th>
            <th scope="col" (click)="sort('quantidade')">
              <span
                *ngIf="key === 'quantidade'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Quantidade
            </th>
            <th scope="col" (click)="sort('quantidadeSeguro')">
              <span
                *ngIf="key === 'quantidadeSeguro'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Quantidade Seguro
            </th>
            <th scope="col" (click)="sort('quantidadeAssistencia')">
              <span
                *ngIf="key === 'quantidadeAssistencia'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Quantidade Assistência
            </th>
            <th scope="col" (click)="sort('producao')">
              <span
                *ngIf="key === 'producao'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Produção
            </th>
            <th scope="col" (click)="sort('valorSeguro')">
              <span
                *ngIf="key === 'valorSeguro'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Valor do Seguro
            </th>
            <th scope="col" (click)="sort('valorAssistencia')">
              <span
                *ngIf="key === 'valorAssistencia'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Valor da Assistência
            </th>
            <th scope="col">Detalhes</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="
              let relatorio of relatorios
                | filter: filter
                | orderBy: key:reverse;
              let i = index
            "
          >
            <td>{{ i + 1 }}</td>
            <td>{{ relatorio.idLojista }}</td>
            <td>{{ relatorio.nomeFantasiaLojista }}</td>
            <td>{{ relatorio.quantidade }}</td>
            <td>{{ relatorio.quantidadeSeguro }}</td>
            <td>{{ relatorio.quantidadeAssistencia }}</td>
            <td>{{ relatorio.producao | currency: 'BRL' }}</td>
            <td>{{ relatorio.valorSeguro | currency: 'BRL' }}</td>
            <td>{{ relatorio.valorAssistencia | currency: 'BRL' }}</td>
            <td class="p-5">
              <button
                class="btn gerar-relatorio"
                (click)="onClickGerarRelatorio(0, 50, relatorio.idLojista)"
              >
                <span class="fa fa-plus-circle fa-2x color-blue"></span>
              </button>
            </td>
          </tr>
        </tbody>

        <tfoot *ngIf="totais">
          <tr>
            <th scope="row"></th>
            <th scope="row"></th>
            <th scope="row">Quantidade Total de Contrato(s)</th>
            <td>{{ totais.totalContratos }}</td>
            <td>{{ totais.totalSeguros }}</td>
            <td>{{ totais.totalAssistencia }}</td>
            <td>{{ totais.totalValorProducao | currency: 'BRL' }}</td>
            <td>{{ totais.totalValorSeguro | currency: 'BRL' }}</td>
            <td>{{ totais.totalValorAssistencia | currency: 'BRL' }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>

      <table
        aria-describedby="descricao-tabela"
        class="table"
        *ngIf="!isLojaMatriz"
      >
        <thead>
          <tr>
            <th scope="col" (click)="sort('proposta')">
              <span
                *ngIf="key === 'proposta'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Proposta
            </th>
            <th scope="col" (click)="sort('emissao')">
              <span
                *ngIf="key === 'emissao'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Emissão
            </th>
            <th
              scope="col"
              (click)="sort('contrato')"
              *ngIf="!isRelatorioPropostasGeradas"
            >
              <span
                *ngIf="key === 'contrato'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Contrato
            </th>
            <th scope="col" (click)="sort('cliente.cpf')">
              <span
                *ngIf="key === 'cliente.cpf'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              CPF
            </th>
            <th scope="col" (click)="sort('cliente.nome')">
              <span
                *ngIf="key === 'cliente.nome'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Cliente
            </th>
            <th scope="col" (click)="sort('valorFinanciado')">
              <span
                *ngIf="key === 'valorFinanciado'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Valor Financiado
            </th>
            <th
              scope="col"
              (click)="sort('quantidadeParcelas')"
              *ngIf="isRelatorioProducao"
            >
              <span
                *ngIf="key === 'quantidadeParcelas'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Parcelas
            </th>
            <ng-container *ngIf="isParceriaDell">
              <th scope="col" (click)="sort('valorParcelas')">
                <span
                  *ngIf="key === 'valorParcelas'"
                  class="fa"
                  [ngClass]="{
                    'fa-arrow-up': reverse,
                    'fa-arrow-down': !reverse
                  }"
                ></span>
                Valor Parcela
              </th>

              <th scope="col" (click)="sort('valorLiberado')">
                <span
                  *ngIf="key === 'valorLiberado'"
                  class="fa"
                  [ngClass]="{
                    'fa-arrow-up': reverse,
                    'fa-arrow-down': !reverse
                  }"
                ></span>
                Valor Liberado
              </th>
            </ng-container>
            <th scope="col" (click)="sort('valorTac')">
              <span
                *ngIf="key === 'valorTac'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              TAC
            </th>
            <th scope="col" (click)="sort('valorIof')">
              <span
                *ngIf="key === 'valorIof'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              IOF
            </th>
            <ng-container *ngIf="!isParceriaDell">
              <th scope="col" (click)="sort('valorSeguro')">
                <span
                  *ngIf="key === 'valorSeguro'"
                  class="fa"
                  [ngClass]="{
                    'fa-arrow-up': reverse,
                    'fa-arrow-down': !reverse
                  }"
                ></span>
                Seguro
              </th>
              <th scope="col" (click)="sort('valorAssistencia')">
                <span
                  *ngIf="key === 'valorAssistencia'"
                  class="fa"
                  [ngClass]="{
                    'fa-arrow-up': reverse,
                    'fa-arrow-down': !reverse
                  }"
                ></span>
                Assistência
              </th>
              <th
                class="position-relative"
                scope="col"
                (click)="sort('valorLoja')"
              >
                <span
                  *ngIf="key === 'valorLoja'"
                  class="fa"
                  [ngClass]="{
                    'fa-arrow-up': reverse,
                    'fa-arrow-down': !reverse
                  }"
                ></span>
                Loja
                <saiba-mais
                  class="align-icon"
                  *ngIf="isRelatorioProducao && isCessao"
                  [isPopoverOnHover]="true"
                  [isSmall]="true"
                  [backgroundBlue]="true"
                  placement="left"
                  texto="Os campos serão apresentados em branco caso não tenha sido assinado o termo de cessão, valor é atualizado após liberação."
                ></saiba-mais>
              </th>
              <th
                scope="col"
                (click)="sort('valoresFabricas')"
                *ngIf="isRelatorioProducao && !isFabricaEmpty"
              >
                <span
                  *ngIf="key === 'valoresFabricas'"
                  class="fa"
                  [ngClass]="{
                    'fa-arrow-up': reverse,
                    'fa-arrow-down': !reverse
                  }"
                ></span>
                Fábrica
              </th>
            </ng-container>

            <th scope="col" (click)="sort('retencao')" *ngIf="isParceriaDell">
              <span
                *ngIf="key === 'retencao'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Percentual de Retenção
            </th>

            <th
              class="position-relative"
              scope="col"
              (click)="sort('dataPagamento')"
              *ngIf="
                (isRelatorioProducao && !isDataPgmtEmpty) || isParceriaDell
              "
            >
              <span
                *ngIf="key === 'dataPagamento'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Data Pgto

              <saiba-mais
                *ngIf="isParceriaDell"
                class="align-icon"
                [isPopoverOnHover]="true"
                [isSmall]="true"
                [backgroundBlue]="true"
                placement="left"
                texto="Esta data é uma previsão de pagamento, qualquer alteração durante a finalização ela pode ser alterada."
              ></saiba-mais>
            </th>

            <ng-container *ngIf="isRelatorioContratosCancelados">
              <th scope="col" (click)="sort('dataCancelamento')">
                <span
                  *ngIf="key === 'dataCancelamento'"
                  class="fa"
                  [ngClass]="{
                    'fa-arrow-up': reverse,
                    'fa-arrow-down': !reverse
                  }"
                ></span>
                Data Cancelamento
              </th>
              <th scope="col" (click)="sort('valorCancelamento')">
                <span
                  *ngIf="key === 'valorCancelamento'"
                  class="fa"
                  [ngClass]="{
                    'fa-arrow-up': reverse,
                    'fa-arrow-down': !reverse
                  }"
                ></span>
                Cancelamento
              </th>
            </ng-container>
            <th
              scope="col"
              (click)="sort('statusProposta')"
              *ngIf="isRelatorioPropostasGeradas"
            >
              <span
                *ngIf="key === 'statusProposta'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Status
            </th>
            <th
              scope="col"
              (click)="sort('pagamentoRealizado')"
              *ngIf="isParceriaDell"
            >
              <span
                *ngIf="key === 'pagamentoRealizado'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Status Pgto
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="
              let relatorio of relatorios
                | filter: filter
                | orderBy: key:reverse;
              let i = index
            "
          >
            <td>{{ relatorio.proposta }}</td>
            <td>{{ relatorio.emissao | date: 'dd/MM/y' }}</td>
            <td *ngIf="!isRelatorioPropostasGeradas">
              {{ relatorio.contrato }}
            </td>
            <td *ngIf="relatorio.cliente">{{ relatorio.cliente.cpf | cpf }}</td>
            <td *ngIf="relatorio.cliente">{{ relatorio.cliente.nome }}</td>
            <td>{{ relatorio.valorFinanciado | currency: 'BRL' }}</td>
            <td *ngIf="isRelatorioProducao">
              {{ relatorio.quantidadeParcelas }}
            </td>
            <ng-container *ngIf="isParceriaDell">
              <td>
                {{
                  (relatorio.valorParcelas ? relatorio.valorParcelas : 0)
                    | currency: 'BRL'
                }}
              </td>
              <td>
                {{
                  (relatorio.valorLiberado ? relatorio.valorLiberado : 0)
                    | currency: 'BRL'
                }}
              </td>
            </ng-container>
            <td>{{ relatorio.valorTac | currency: 'BRL' }}</td>
            <td>{{ relatorio.valorIof | currency: 'BRL' }}</td>
            <ng-container *ngIf="!isParceriaDell">
              <td>
                {{ relatorio.valorSeguro | currency: 'BRL' }}
              </td>
              <td>
                {{ relatorio.valorAssistencia | currency: 'BRL' }}
              </td>
              <td>
                {{ relatorio.valorLoja | currency: 'BRL' }}
              </td>
              <td *ngIf="isRelatorioProducao && !isFabricaEmpty">
                <span>
                  <ul
                    class="lista-fabricas"
                    *ngFor="let fabrica of relatorio.valoresFabricas"
                  >
                    <li>
                      {{ fabrica.valor | currency: 'BRL' }}
                      <em
                        class="fa fa-info-circle"
                        [title]="fabrica.nomeFabrica"
                      ></em>
                    </li>
                  </ul>
                </span>
              </td>
            </ng-container>
            <td *ngIf="isParceriaDell">{{ relatorio.retencao }}%</td>
            <td
              *ngIf="
                (isRelatorioProducao && !isDataPgmtEmpty) || isParceriaDell
              "
            >
              {{ relatorio.dataPagamento | date: 'dd/MM/y' }}
            </td>
            <ng-container *ngIf="isRelatorioContratosCancelados">
              <td>
                {{ relatorio.dataCancelamento | date: 'dd/MM/y' }}
              </td>
              <td>
                {{ relatorio.valorCancelamento | currency: 'BRL' }}
              </td>
            </ng-container>
            <td *ngIf="isRelatorioPropostasGeradas">
              {{ relatorio.statusProposta }}
            </td>
            <td class="text-left" *ngIf="isParceriaDell">
              {{
                relatorio.pagamentoRealizado
                  ? 'Pgto Realizado'
                  : 'Pgto Pendente'
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <ng-template #relatorioFabricaTemplate>
      <table
        aria-describedby="descricao-tabela"
        id="relatorioFabrica"
        class="table"
      >
        <thead>
          <tr>
            <th scope="col" (click)="sort('emissao')">
              <span
                *ngIf="key === 'emissao'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Emissão
            </th>
            <th scope="col" (click)="sort('contrato')">
              <span
                *ngIf="key === 'contrato'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Contrato
            </th>

            <th
              *ngIf="filtros?.relatorio?.idRelatorio === 16 && isLojaMatriz"
              scope="col"
              (click)="sort('lojista.razaoSocial')"
            >
              <span
                *ngIf="key === 'lojista.razaoSocial'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Loja
            </th>

            <th scope="col" (click)="sort('cliente.cpf')">
              <span
                *ngIf="key === 'cliente.cpf'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              CPF
            </th>
            <th scope="col" (click)="sort('cliente.nome')">
              <span
                *ngIf="key === 'cliente.nome'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Cliente
            </th>
            <th scope="col" (click)="sort('quantidadeParcelas')">
              <span
                *ngIf="key === 'quantidadeParcelas'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Parcelas
            </th>
            <th scope="col" (click)="sort('valorParcelas')">
              <span
                *ngIf="key === 'valorParcelas'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              VL Parcela
            </th>
            <th scope="col" (click)="sort('valorLiberado')">
              <span
                *ngIf="key === 'valorLiberado'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              VL Liberado
            </th>
            <th scope="col" (click)="sort('valorFabrica')">
              <span
                *ngIf="key === 'valorFabrica'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              VL Fábrica
            </th>
            <th scope="col" (click)="sort('valorLojaVO.valor')">
              <span
                *ngIf="key === 'valorLojaVO.valor'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              VL Loja
            </th>
            <th scope="col" (click)="sort('dataPagamento')">
              <span
                *ngIf="key === 'dataPagamento'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Data Pgto
            </th>
            <th scope="col" (click)="sort('pagamentoRealizado')">
              <span
                *ngIf="key === 'pagamentoRealizado'"
                class="fa"
                [ngClass]="{
                  'fa-arrow-up': reverse,
                  'fa-arrow-down': !reverse
                }"
              ></span>
              Status Pgto
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="
              let relatorio of relatorios
                | filter: filter
                | orderBy: key:reverse;
              let i = index
            "
          >
            <td>{{ relatorio.emissao | date: 'dd/MM/y' }}</td>
            <td>{{ relatorio.contrato }}</td>
            <td *ngIf="filtros?.relatorio?.idRelatorio === 16 && isLojaMatriz">
              {{ relatorio?.lojista?.razaoSocial }}
            </td>
            <td>{{ relatorio?.cliente.cpf | cpf }}</td>
            <td class="text-left">{{ relatorio?.cliente.nome }}</td>
            <td>{{ relatorio.quantidadeParcelas }}</td>
            <td>{{ relatorio.valorParcelas | currency: 'BRL' }}</td>
            <td>{{ relatorio.valorLiberado | currency: 'BRL' }}</td>
            <td>{{ relatorio.valorFabrica | currency: 'BRL' }}</td>
            <td>{{ relatorio?.valorLojaVO?.valor | currency: 'BRL' }}</td>
            <td>{{ relatorio.dataPagamento | date: 'dd/MM/y' }}</td>
            <td class="text-left">
              {{
                relatorio.pagamentoRealizado
                  ? 'Pgto Realizado'
                  : 'Pgto Pendente'
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </ng-template>

    <div class="pagination-container" *ngIf="page && !page.empty && !filter">
      <div>
        Mostrando: {{ page.number * page.size + 1 }} até
        <span> {{ page.number * page.size + page.numberOfElements }} </span>
        de
        <span> {{ page.totalElements }} </span>
      </div>

      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item" [ngClass]="page.first ? 'disabled' : ''">
            <a
              class="page-link cursor-pointer"
              (click)="page.first ? null : onClickChangePage(page.number - 1)"
              aria-label="Previous"
            >
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>

          <li
            class="page-item"
            *ngFor="let pageAux of page.pages"
            [ngClass]="pageAux == page.number ? 'active' : ''"
            [ngClass]="i == page.number ? 'active' : ''"
          >
            <a
              class="page-link cursor-pointer"
              (click)="onClickChangePage(pageAux)"
              >{{ pageAux + 1 }}</a
            >
          </li>

          <li class="page-item" [ngClass]="page.last ? 'disabled' : ''">
            <a
              class="page-link cursor-pointer"
              (click)="page.last ? null : onClickChangePage(page.number + 1)"
              aria-label="Next"
            >
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>

          <select
            (ngModelChange)="onClickChangePage()"
            [(ngModel)]="size"
            class="custom-select"
          >
            <option value="50" selected>50</option>
            <option value="100">100</option>
          </select>
        </ul>
      </nav>
    </div>
  </div>
</div>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>
